<div id="shipperDetails" class="pr-2" [formGroup]="dgContentForm">
  <h4 class="text-center">
    {{ 'maw.mawList.dgContent.dGContentIDDetails' | translate }}
  </h4>
  <div class="secondary-details mb-2">
    <!-- <span class="header">DG Content ID Details </span> <br /> -->
    <label class="message">
      {{ 'maw.mawList.dgContent.pleaseSelectDGIfApplicable' | translate }}
    </label>
  </div>
  <div class="text-end icon-mat-close">
    <i mat-dialog-close class="bi bi-x"></i>
  </div>

  <div class="row header">
    <div class="col-md-12">
      <mat-form-field appearance="none">
        <label> {{ 'maw.mawList.dgContent.dGContentID' | translate }}: </label>
        <mat-select
          disableRipple
          class="form-control"
          formControlName="DGContentID"
          multiple
          (selectionChange)="changeDgContentID($event)">
          <mat-option *ngFor="let eachId of dgContentIdsList" [value]="eachId?.dg_content_id">
            {{ eachId?.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container>
        <div class="row">
          <div class="col-md-7 no-margin">
            <div
              class="no-margin"
              *ngIf="
                dgSelected(enumDGPackage.BiologicalSubstance) || dgSelected(enumDGPackage.DryIce)
              ">
              <mat-tab-group mat-align-tabs="start" [(selectedIndex)]="selectedDGTabIndex">
                <mat-tab *ngFor="let dg of selectedDGPackage" label="{{ dg.name }}"></mat-tab>
              </mat-tab-group>
            </div>
            <div
              [style.display]="selectedDGTabIndex == i ? 'block' : 'none'"
              *ngFor="let dg of selectedDGPackage; let i = index">
              <div *ngIf="dg.dg_content_id == enumDGPackage.BiologicalSubstance">
                <app-dgpackages
                  [DGType]="dg.dg_content_id"
                  (valueChange)="dgPackageBiologicalValueChange($event)"
                  [(value)]="dgPackageBiologicalValue"></app-dgpackages>
              </div>
              <div *ngIf="dg.dg_content_id == enumDGPackage.DryIce">
                <app-dgpackages
                  [DGType]="dg.dg_content_id"
                  (valueChange)="dgPackageDryIcelValueChange($event)"
                  [(value)]="dgPackageDryIcelValue"></app-dgpackages>
              </div>
            </div>
          </div>
          <div
            class="col-md-5 no-margin"
            *ngIf="
              dgSelected(enumDGPackage.BiologicalSubstance) || dgSelected(enumDGPackage.DryIce)
            ">
            <label>Description:</label>
            <div *ngFor="let dg of dgPackageBiologicalValue">
              <label *ngIf="dg.packageNo > 0">
                {{ dg.packageNo }} Package UN3373 Biological Substance
              </label>
            </div>
            <div *ngFor="let dg of dgPackageDryIcelValue">
              <label *ngIf="dg.packageNo > 0 && dg.packageWeight > 0">
                UN1845 Dry Ice, Net {{ dg.packageNo }} x {{ dg.packageWeight }} kg
              </label>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showDgCustomDescription">
        <div class="col-md-18">
          <mat-form-field appearance="none">
            <label class="required-field">
              {{ 'maw.mawList.dgContent.dGCustomDescription' | translate }} </label
            >:
            <mat-select
              disableRipple
              class="form-control"
              formControlName="DGCustomDescription"
              [(value)]="selectedDescription"
              (selectionChange)="selected($event)">
              <mat-option
                [matTooltip]="description"
                *ngFor="let description of customDescriptions"
                [value]="description">
                {{ description }}
              </mat-option>
            </mat-select>
            <app-error-component
              [controlName]="dgContentForm.get('DGCustomDescription')"></app-error-component>
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <mat-dialog-actions align="end">
      <button class="primary-btn" (click)="addDgValues()" [disabled]="!disableSave()">
        {{ 'maw.mawList.dgContent.addDGValues' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
